export const SpoqaHanSansNeoThin = require("./SpoqaHanSansNeo-Thin.woff2");
export const SpoqaHanSansNeoRegular = require("./SpoqaHanSansNeo-Regular.woff2");
export const SpoqaHanSansNeoMedium = require("./SpoqaHanSansNeo-Medium.woff2");
export const SpoqaHanSansNeoLight = require("./SpoqaHanSansNeo-Light.woff2");
export const SpoqaHanSansNeoBold = require("./SpoqaHanSansNeo-Bold.woff2");
